// extracted by mini-css-extract-plugin
export default {"container":"_1gKn","blue":"CaBr","red":"_1Ns8","status":"_3fln"};